import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaFolder, FaSearch } from "react-icons/fa";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { Link } from "react-router-dom";

export default function Folder() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [folderContents, setFolderContents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    GetFolderContents();
  }, [clientId]);

  const GetFolderContents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        config.APIACTIVATEURL +
          config.GETFOLDERBYCLIENT +
          "?clientId=" +
          clientId,
        {
          ...headerconfig,
        }
      );
      if (response.data.statusCode === 200) {
        const folderData = response.data.data?.data;
        setFolderContents(Array.isArray(folderData) ? folderData : []);
      } else {
        setError("Error fetching folder contents.");
      }
    } catch (error) {
      setError("Error fetching folder contents: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFolderClick = (folderId) => {
    navigate("/folder/" + folderId);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(e.target.value.length > 0);
  };

  const handleDropdownClick = (folderName) => {
    setSearchTerm(folderName);
    setShowDropdown(false);
  };

  const filteredFolders = searchTerm
    ? folderContents.filter((folder) =>
        folder.folderName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : folderContents;

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Folders</h4>
                  <div className="page-title-right">
                    <Link to="/clientfolder" className="btn btn-secondary">
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  {error ? (
                    <p className="text-danger">{error}</p>
                  ) : filteredFolders.length === 0 ? (
                    <p colSpan="6" className="text-center">
                      No folders available.
                    </p>
                  ) : (
                    <div className="card-body">
                      <div className="row">
                        {filteredFolders.map((folder, index) => (
                          <div
                            key={folder.folderId || index}
                            className="col-lg-3 col-md-4 col-sm-6 mb-4"
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="card text-center shadow-sm"
                              onClick={() => handleFolderClick(folder.folderId)}
                            >
                              <div className="card-body">
                                <div className="folder-icon mb-3">
                                  <FaFolder size={40} color="#ff8c00" />{" "}
                                </div>
                                <div className="folder-name">
                                  {folder.folderName}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
